export interface AuthenticationConf {
	loginUrl: string;
	baseUrl: string;
	clientId: string;
	clientSecret: string;
}

export const authenticationConf: AuthenticationConf = {
	loginUrl: '',
	baseUrl: '',
	clientId: '',
	clientSecret: ''
};
